import { g as o, q as s } from "./export-cdcbfb2b.js";
var e = o, a = s, i = Object.getOwnPropertyDescriptor, c = function(r) {
  if (!a)
    return e[r];
  var t = i(e, r);
  return t && t.value;
};
export {
  c as s
};
